/* Ficha de la membresía (tema Shopify): titular de la cabecera a su columna, movimiento de la tarjeta y banda de 4 palabras al mismo cuerpo.
   Copia de los <script> de la maqueta v4, 14-oct-2026, Claude Code 497b66e1. Lo carga sections/mg-club-compra.liquid. */
/* cabecera del club: el texto empieza bajo la cabecera fija y el titular ocupa su columna sin salirse */
(function(){
  var W = document.querySelector('.mgcx'); if (!W) return;
  var h = W.querySelector('.mgh2-h'), col = W.querySelector('.mgh2-t');
  function lay(){
    var b = 0;
    [].forEach.call(document.querySelectorAll('header, .ann'), function(e){ if (getComputedStyle(e).position === 'fixed') b = Math.max(b, e.getBoundingClientRect().bottom); });
    W.style.setProperty('--mgt', Math.round(b || 96) + 'px');
    if (h && col){ var cw = col.clientWidth, cap = innerHeight * (innerWidth <= 760 ? .2 : .115), fs = 100, ls = h.querySelectorAll('.l'); [].forEach.call(ls, function(l){ l.style.fontSize = ''; l.style.display = 'block'; l.style.width = 'max-content'; }); h.style.fontSize = fs + 'px'; for (var k = 0; k < 3; k++){ var w = 0; [].forEach.call(ls, function(l){ w = Math.max(w, l.getBoundingClientRect().width); }); if (!w) break; fs = Math.min(fs * cw / w, cap); h.style.fontSize = fs.toFixed(2) + 'px'; } }
  }
  lay(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(lay);
  addEventListener('load', lay);
  var t; addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(lay, 120); });
})();
/* cabecera del club: movimiento de la tarjeta (deriva lenta sola, sigue al ratón por toda la cabecera, giro suave al pulsar) */
(function(){
  var wrap = document.querySelector('.mgh2-card'); if (!wrap) return;
  var card = wrap.querySelector('.mc3'); if (!card) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var hero = wrap.closest('.cx') || document.body, tx = 0, ty = 0, x = 0, y = 0, fl = 0, has = false, on = true, t0 = performance.now();
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (fine){
    hero.addEventListener('pointermove', function(e){ var r = hero.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width - .5; ty = (e.clientY - r.top) / r.height - .5; has = true; });
    hero.addEventListener('pointerleave', function(){ has = false; });
  }
  if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ on = es[0].isIntersecting; if (on) requestAnimationFrame(loop); }).observe(hero);
  function loop(t){
    if (!on) return;
    var cd = card.querySelector('.cd'); if (!cd){ requestAnimationFrame(loop); return; }
    var k = (t - t0) / 1000, ix = has ? tx : Math.sin(k * .5) * .32, iy = has ? ty : Math.cos(k * .37) * .22;
    x += (ix - x) * .055; y += (iy - y) * .055;
    fl += ((card.classList.contains('flip') ? 180 : 0) - fl) * .085;
    cd.style.setProperty('--ry', (x * 34 - 14).toFixed(2) + 'deg');
    cd.style.setProperty('--rx', (-y * 20 + 7).toFixed(2) + 'deg');
    cd.style.setProperty('--flip', fl.toFixed(2) + 'deg');
    cd.style.setProperty('--gx', (50 + x * 110).toFixed(1) + '%'); cd.style.setProperty('--gy', (35 + y * 90).toFixed(1) + '%');
    cd.style.setProperty('--fx', (50 + x * 100).toFixed(1) + '%'); cd.style.setProperty('--fy', (50 + y * 100).toFixed(1) + '%');
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);
})();
/* «Todo lo que te da el club»: las 4 palabras de la banda al mismo cuerpo, el mayor con el que cabe la más larga */
(function(){
  var band = document.querySelector('.mgr-band'); if (!band) return;
  function fit(){
    var bs = [].slice.call(band.querySelectorAll('b')); if (!bs.length) return;
    bs.forEach(function(b){ b.style.fontSize = '100px'; });
    var ratio = Infinity;
    bs.forEach(function(b){ var li = b.parentNode, cs = getComputedStyle(li), inner = li.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight), r = document.createRange(); r.selectNodeContents(b); var w = r.getBoundingClientRect().width; if (w) ratio = Math.min(ratio, inner / w); });
    var fs = Math.min(100 * ratio * .98, innerWidth <= 760 ? 56 : 84);
    bs.forEach(function(b){ b.style.fontSize = fs.toFixed(1) + 'px'; });
  }
  fit(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  var t; addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(fit, 120); });
})();
/* Regalos de Bryant: se abre el panel que pasas o tocas (como la home) */
(function(){
  var ps = [].slice.call(document.querySelectorAll('.mgrg-p')); if (!ps.length) return;
  function on(p){ ps.forEach(function(x){ x.classList.toggle('is-on', x === p); }); }
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  ps.forEach(function(p){
    if (fine) p.addEventListener('pointerenter', function(){ on(p); });
    p.addEventListener('click', function(){ on(p); });
    p.addEventListener('focus', function(){ on(p); });
    p.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); on(p); } });
  });
})();
/* «Entra en la gang.»: una sola línea, al mayor cuerpo que cabe en su columna (tope 104 px) */
(function(){
  var h = document.querySelector('.mgb-h'); if (!h) return;
  function fit(){
    if (innerWidth <= 760){ h.style.fontSize = ''; return; }
    h.style.fontSize = '100px';
    var r = document.createRange(); r.selectNodeContents(h);
    var w = r.getBoundingClientRect().width, col = h.clientWidth;
    if (w) h.style.fontSize = Math.min(104, 100 * col / w * .98).toFixed(1) + 'px';
  }
  fit(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  var t; addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(fit, 120); });
})();
